module.exports = "../fonts/location_mark.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/location_mark.svg
// module id = 388
// module chunks = 0